module.exports = __webpack_public_path__ + "img/naturalbeige.e0cf13d.webp";